import classNames from 'classnames';
import { IIconWrapperProps } from './interfaces';
import './style.scss';

const IconWrapper = ({
  children,
  size,
  color = 'text-primary',
  rotate,
  button,
  onClick
}: IIconWrapperProps) => {
  const iconWrapperClass = classNames('icon-wrapper', {
    [color]: true,
    button,
    rotate
  });

  return (
    <div style={{ fontSize: `${size}px` }} onClick={onClick} className={iconWrapperClass}>
      {children}
    </div>
  );
};

export default IconWrapper;
